import get from 'lodash/get';
import set from 'lodash/set';
import actions from './actions';
import mutations from './mutations';
import state from './state';
import { collectAttributes } from './utils';
import { filterOverlays, unitList } from './getters';

const SUPPORTED_CONTROLS = {
  checkbox: 'checkbox',
  slider: 'slider',
  simpleCheckbox: 'single_checkbox',
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters: {
    unitList,
    filterOverlays,
    activeFilters: state => state.activeFilters,
    filtersAreEmpty: state => !state.activeFilters.length,
    filtersSorted(state, getters, rootState, rootGetters) {
      const attributeIndex = rootGetters['units/normalizedUnits'].reduce((res, unit) => Object
        .entries(collectAttributes(unit))
        .reduce((res, [key, value]) => set(
          res, [key],
          get(res, [key], new Set())
            .add(value),
        ), res), {});
      const sorters = {
        status: rootGetters['project/sortStatusesByWeight'],
      };

      return state.filters.map(filter => set(
        Object.assign({}, filter),
        ['options'],
        Array.from(attributeIndex[filter.key] || [])
          .sort(sorters[filter.key]),
      ));
    },
    filterCheckers: () => ({
      isCheckBox: val => val === SUPPORTED_CONTROLS.checkbox,
      isSingleCheckBox: val => val === SUPPORTED_CONTROLS.simpleCheckbox,
      isSlider: val => val === SUPPORTED_CONTROLS.slider,
      isValidControl: val => Object.values(SUPPORTED_CONTROLS)
        .includes(val),
    }),
  },
};
